import { ProviderAccounts } from '@/features/integrations/ProviderAccounts';
import { useSeesProviders } from '@/lib/useAudience';
import { SourceControl } from '@/features/source-control/SourceControl';

function PageHeader({ operator }: { operator: boolean }) {
  return (
    <header className="enter">
      <h1 className="text-2xl font-semibold tracking-tight text-foreground">Integrations</h1>
      <p className="mt-1 text-sm text-muted-foreground">
        {operator ? 'The build services your apps run on, and the Bitbucket workspaces Hangar reads your code from.' : 'The Bitbucket workspaces Hangar reads your code from.'}
      </p>
    </header>
  );
}

/**
 * Screen 11: build provider accounts and source control (Bitbucket). Clients only see source control: the provider
 * accounts behind Hangar are for platform operators (SPEC decision 23). The "CI access" card returns with CLI and CI
 * builds (docs/mvp-plan.md P17); the "Arriving later" tiles (webhooks and PR feedback, stores, notifications) with P18.
 */
export function IntegrationsPage() {
  const operator = useSeesProviders();
  return (
    <div className="flex min-w-0 flex-col gap-5">
      <PageHeader operator={operator} />
      {operator ? <ProviderAccounts /> : null}
      <SourceControl />
    </div>
  );
}
